import React, {
  ChangeEvent,
  FC,
  FocusEvent,
  KeyboardEvent,
  RefObject,
} from 'react'
import './TextArea.css'

export type TextAreaFieldProps = {
  label?: React.ReactNode
  placeholder?: string
  value?: string
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void
  onFocus?: (event: FocusEvent<HTMLTextAreaElement>) => void
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void
  disabled?: boolean
  hint?: string
  destructive?: boolean
  rows?: number
  className?: string
  id?: string
  ref?: RefObject<HTMLTextAreaElement>
  required?: boolean
  isControlled?: boolean
  handleKeyDown?: (event: KeyboardEvent<HTMLTextAreaElement>) => void
}

const TextAreaField: FC<TextAreaFieldProps> = ({
  label,
  placeholder = '',
  value = '',
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  hint,
  destructive = false,
  rows = 3,
  className = '',
  id,
  ref,
  required = false,
  isControlled = true,
  handleKeyDown,
}) => {
  const safeValue = value ?? ''

  return (
    <div
      className={`textarea-container${destructive ? ' textarea-container-destructive' : ''} ${className}`.trim()}
    >
      {label && <label className="textarea-label">{label}</label>}
      <div className="textarea-wrapper">
        <textarea
          ref={ref}
          id={id}
          className={`textarea${destructive ? ' textarea-destructive' : ''}${disabled ? ' textarea-disabled' : ''}`}
          placeholder={placeholder}
          rows={rows}
          {...(isControlled ? { value: safeValue } : {})}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          aria-invalid={destructive || undefined}
          onKeyDown={handleKeyDown}
          required={required}
        />
      </div>
      {hint && (
        <span
          className={`textarea-hint${destructive ? ' textarea-hint-destructive' : ''}`}
        >
          {hint}
        </span>
      )}
    </div>
  )
}

export default TextAreaField
